import { map } from "lodash";
import { ExportCategories } from "PFApp/analytics/types/export_analytics";
import React, { JSX } from "react";

import { FieldCategory } from "./field_category";

interface FieldsSelectorProps {
  items: ExportCategories;
  allExpanded: boolean;
}

export const FieldsSelector = ({ items, allExpanded }: FieldsSelectorProps): JSX.Element => (
  <div>
    {map(items, (item, key) => (
      <FieldCategory key={key} allExpanded={allExpanded} categoryKey={key} fields={item} />
    ))}
  </div>
);
